<template>
  <div>
    <el-tabs v-model="activeName" class="demo-tabs" @tab-click="handleClick">
      <el-tab-pane label="邀请码渠道" name="first">
        <vab-query-form style="padding-top: 20px">
          <vab-query-form-left-panel :span="6">
            <el-button :icon="Plus" type="primary" @click="handleEdit($event)">添加邀请码渠道</el-button>
          </vab-query-form-left-panel>
          <vab-query-form-right-panel :span="18">
            <el-form :inline="true" :model="queryForm" @submit.prevent>
              <el-form-item label="渠道名称">
                <el-input v-model="queryForm.name" clearable placeholder="请输入渠道名称" />
              </el-form-item>
              <el-form-item label="邀请码">
                <el-input v-model="queryForm.code" clearable placeholder="请输入邀请码" />
              </el-form-item>
              <el-form-item label="渠道状态">
                <el-select v-model="queryForm.status" clearable>
                  <el-option label="使用中" :value="'IN_USE'" />
                  <el-option label="已停用" :value="'DEACTIVATED'" />
                </el-select>
              </el-form-item>
              <el-form-item>
                <el-button :icon="Search" type="primary" @click="queryData">查询</el-button>
              </el-form-item>
            </el-form>
          </vab-query-form-right-panel>
        </vab-query-form>
        <el-table v-loading="listLoading" border :data="list">
          <el-table-column fixed label="渠道名称" prop="channelName" width="150" />
          <el-table-column fixed label="邀请码" prop="invitationCode" width="150" />
          <el-table-column label="邀请身份">
            <template #default="{ row }">
              {{ handleUserIdentity(row.identity) }}
            </template>
          </el-table-column>
          <el-table-column label="使用场景">
            <template #default="{ row }">
              {{ userSceneMap[row.useScene] }}
            </template>
          </el-table-column>
          <el-table-column label="生成时间">
            <template #default="{ row }">
              {{ parseTimeFunc(row.createTime) }}
            </template>
          </el-table-column>
          <el-table-column label="报名次数总量">
            <template #default="{ row }">
              {{ row.total }}
            </template>
          </el-table-column>
          <el-table-column label="剩余可报名次数" prop="defineUseNum" />
          <el-table-column label="状态" width="150">
            <template #default="{ row }">
              <el-select v-model="row.status" @change="handleChangstatus(row, $event)">
                <el-option label="使用中" :value="'IN_USE'" />
                <el-option label="已停用" :value="'DEACTIVATED'" />
              </el-select>
            </template>
          </el-table-column>
          <el-table-column label="已报名人数" prop="signUpNum" show-overflow-tooltip />
          <el-table-column v-if="type == 'EXHIBITION'" label="签到人数" prop="signInNum" show-overflow-tooltip />
          <el-table-column fixed="right" label="操作" width="460">
            <template #default="{ row }">
              <el-button type="primary" @click="handleEdit(row)">
                <vab-icon icon="edit-2-line" />
                编辑
              </el-button>
              <el-button type="primary" @click="handleChangeNum(row)">修改次数</el-button>
              <el-button type="primary" @click="handleSeeDetail(row)">查看数据</el-button>
              <el-button type="success" @click="handleImportUser(row)">用户导入</el-button>
              <el-button type="success" @click="handleImportResult(row)">导入结果</el-button>
            </template>
          </el-table-column>
          <template #empty>
            <el-empty class="vab-data-empty" description="暂无数据" />
          </template>
        </el-table>
        <el-pagination
          background
          :current-page="queryForm.pageNumber"
          :layout="layout"
          :page-size="queryForm.pageSize"
          :total="total"
          @current-change="handleCurrentChange"
          @size-change="handleSizeChange"
        />

        <edit
          ref="editRef"
          :identity-list="identityList"
          :meeting-code="queryForm.meetingCode"
          :meeting-type="queryForm.meetingType"
          @fetch-data="fetchData"
        />
        <sharecodeUseNum ref="sharecodeNumRef" @fetch-data="fetchData" />
        <shareCodeDetail ref="channelDetailRef" />
        <upload-file ref="upLoadRef" :identity-options="identityOptions" :is-j-b-h="isJBH" @fetch-data="fetchData" />
        <upload-result ref="resultRef" @fetch-data="fetchData" />
      </el-tab-pane>
      <el-tab-pane label="邀请码配置" name="second">
        <sharecodeConfig ref="shareCodeConfigRef" />
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
  import { defineComponent, defineAsyncComponent, getCurrentInstance, onMounted, reactive, toRefs, watch } from 'vue'

  import { Delete, Plus, Search } from '@element-plus/icons'
  import { channelInvitationList, channelInvitationUpdateStatus } from '@/api/channel'

  import { getRegisterConfigList, getIdentityOptions } from '@/api/exhibitionManage'
  import shareCodeDetail from './components/shareCodeDetail.vue'
  import sharecodeUseNum from './components/sharecodeUseNum.vue'
  import { parseTime } from '@/utils/index'
  import sharecodeConfig from './sharecodeConfig.vue'
  export default defineComponent({
    name: 'SharecodeChannel',
    components: {
      Edit: defineAsyncComponent(() => import('./components/sharecodeChannelEdit')),
      uploadFile: defineAsyncComponent(() => import('./components/visitorImport')),
      uploadResult: defineAsyncComponent(() => import('./components/uploadResult')),
      shareCodeDetail,
      sharecodeUseNum,
      sharecodeConfig,
    },
    setup() {
      const { proxy } = getCurrentInstance()

      const state = reactive({
        queryForm: {
          pageNum: 1,
          pageSize: 20,
          meetingCode: '',
          code: '',
          name: '',
          status: '',
          meetingType: 'EXHIBITION',
        },
        activeName: 'first',
        total: 0,
        shopList: [],
        listLoading: false,
        list: [],
        layout: 'prev, pager, next',
        editRef: null,
        upLoadRef: null,
        resultRef: null,
        generateWxRef: null,
        exportRegisterRef: null,
        channelDetailRef: null,
        shareCodeConfigRef: null,
        typeOptions: [
          {
            label: '全部',
            value: '',
          },
          {
            label: '申请会议',
            value: 'HOLD_MEETING',
          },
          {
            label: '申请展览',
            value: 'EXHIBITION',
          },
        ],
        identityList: [],
        userSceneMap: {
          FORM: '注册表单',
          TICKET: '购票',
        },
        sharecodeNumRef: null,
        type: proxy.$route.query.meetingType,
        identityOptions: [],
        appKey: '',
        isJBH: (JSON.parse(localStorage.getItem('customInfo')) || {})?.tenantKey === 'J80A84ZBBA40PW1',
      })

      const handleEdit = (row) => {
        if (row.channelId) {
          state.editRef.showEdit(row)
        } else {
          state['editRef'].showEdit()
        }
      }

      const queryData = () => {
        fetchData()
      }

      const fetchData = async () => {
        state.listLoading = true
        const { data } = await channelInvitationList(state.queryForm)
        state.list = data.data
        state.total = data.total
        state.listLoading = false
      }

      const handleSizeChange = (val) => {
        state.queryForm.pageSize = val
        queryData()
      }
      const handleCurrentChange = (val) => {
        state.queryForm.pageNum = val
        queryData()
      }
      watch(
        () => proxy.$route.query,
        async (newVal) => {
          state.type = newVal.meetingType
        }
      )

      onMounted(() => {
        state.queryForm.meetingCode = proxy.$route.query.meetingCode
        state.queryForm.meetingType = proxy.$route.query.meetingType || 'EXHIBITION'
        state.type = proxy.$route.query.meetingType || 'EXHIBITION'

        const info = JSON.parse(localStorage.getItem('customInfo') || '{}')
        if (info.wcs?.[0]?.appKey) state.appKey = info.wcs[0].appKey

        queryData()
        getIdentityData()
        queryIdentityOptions()
      })

      const handleClick = (e) => {
        if (e.index == 1) {
          state.shareCodeConfigRef.queryData()
        } else {
          queryData()
          getIdentityData()
        }
      }

      // 查看数据
      const handleSeeDetail = (row) => {
        state.channelDetailRef.handleOpen(row, state.queryForm.meetingCode, state.type)
      }

      const parseTimeFunc = (val) => {
        return parseTime(val)
      }

      const handleUserIdentity = (val) => {
        return state.identityList.find((v) => v.identity == val).name
      }
      const getIdentityData = async () => {
        let { data: identityList } = await getRegisterConfigList(state.queryForm.meetingCode)
        state.identityList = identityList
      }

      const queryIdentityOptions = () => {
        getIdentityOptions(state.queryForm.meetingCode).then((res) => {
          state.identityOptions = (res.data || []).map((item) => ({
            value: item.identity || item.identityType,
            label: item.name || item.identityName,
          }))
        })
      }

      // 用户导入
      const handleImportUser = (row) => {
        state.upLoadRef.showEdit({
          appKey: state.appKey || row.appKey || '',
          channelNo: row.invitationCode,
          channelName: row.channelName,
          meetingCode: state.queryForm.meetingCode,
          meetingType: state.queryForm.meetingType,
        })
      }
      // 导入结果
      const handleImportResult = (row) => {
        state.resultRef.showEdit({
          meetingCode: state.queryForm.meetingCode,
          channelName: row.channelName,
        })
      }

      const handleChangeNum = (row) => {
        state.sharecodeNumRef.showEdit(row)
      }

      const handleChangstatus = async (row, e) => {
        proxy.$baseConfirm(
          '你确定要修改当前状态吗',
          null,
          async () => {
            await channelInvitationUpdateStatus(row.channelId, e)
            proxy.$baseMessage(`操作成功`, 'success', 'vab-hey-message-success')
            await fetchData()
          },
          async () => {
            row.status = e == 'IN_USE' ? 'DEACTIVATED' : 'IN_USE'
          }
        )
      }

      return {
        ...toRefs(state),
        handleEdit,
        queryData,
        fetchData,
        handleSizeChange,
        handleCurrentChange,
        Delete,
        Search,
        Plus,
        handleSeeDetail,
        parseTimeFunc,
        getIdentityData,
        handleUserIdentity,
        handleChangeNum,
        handleChangstatus,
        handleClick,
        queryIdentityOptions,
        handleImportUser,
        handleImportResult,
      }
    },
  })
</script>
<style lang="scss" scoped></style>
